import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

/**
 * Скрипты расширений браузера: их ошибки не наши, но глобальные обработчики Sentry ловят
 * всё, что падает на странице (ACTOR-FRONT-AM — XHR расширения на /admin-v2). `denyUrls`
 * сверяется с последним кадром стека корневого исключения — ошибка нашего кода, вызванная
 * из расширения, сюда не попадает
 */
export const SENTRY_DENY_URLS = [
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-(web-)?extension:\/\//i,
  /^webkit-masked-url:\/\//i
];

// Инициализация sentry только в production
if (
  import.meta.env.VITE_SERVER_ENVIRONMENT === 'production' ||
  import.meta.env.VITE_SERVER_ENVIRONMENT === 'stage'
) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration()
    ],
    enableLogs: true,
    tracesSampleRate: 1.0,
    release: `actor-front@${import.meta.env.VITE_RELEASE_VERSION}`,
    environment: import.meta.env.VITE_SERVER_ENVIRONMENT,
    sendDefaultPii: true,
    denyUrls: SENTRY_DENY_URLS,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
